import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDivider } from '@angular/material/divider';
import { MatDialog } from '@angular/material/dialog';
import { TenantContextService } from '../../services/tenant-context.service';
import { EditTenantDialogComponent } from '../../dialogs/edit-tenant-dialog/edit-tenant-dialog.component';
import { Tenant } from '../../models/tenant.model';

@Component({
  selector: 'app-overview-tab',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDivider
  ],
  templateUrl: './overview-tab.component.html',
  styleUrl: './overview-tab.component.css'
})
export class OverviewTabComponent {
  tenantContextService = inject(TenantContextService);
  private dialog = inject(MatDialog);

  copyToClipboard(text: string | null | undefined): void {
    if (text) {
      navigator.clipboard.writeText(text);
    }
  }

  openEditTenantDialog(): void {
    const tenant = this.tenantContextService.tenant();
    if (!tenant) return;

    const dialogRef = this.dialog.open(EditTenantDialogComponent, {
      width: '640px',
      data: tenant
    });

    dialogRef.afterClosed().subscribe((updatedTenant?: Tenant) => {
      if (updatedTenant) {
        this.tenantContextService.applyTenantChanges(updatedTenant);
      }
    });
  }

  getEnabledFeaturesCount(): number {
    const tenant = this.tenantContextService.tenant();
    if (!tenant) return 0;

    let count = 0;
    if (tenant.hasDashboardsAccess) count++;
    if (tenant.hasPresentationsAccess) count++;
    if (tenant.hasCognitionAccess) count++;
    return count;
  }

  getTotalFeaturesCount(): number {
    return 3;
  }
}
